import { userConstants } from '../../_constants';
import { userService } from '../../_services';
import { removeUser } from '../../_helpers';
import { alertActions } from '../alertActions';
import { confirmPromptActions } from '../confirmPromptActions';
import { updateUserData, updateUserDataBranch } from '../../_helpers';
export const userActions = {
    getAllUsers,
    getUserById,
    createUser,
    updateUser,
    deleteUser,
    activation,
    setup,
    login,
    logout,
    resendEmail,
    helpSupport,
    updateUserProfile,
    changePassword,
    changePasswordAdmin,
    getUserByIdLogin,

    updateUserCy,
    updateUserBranch,

    getCurrentVersion,

    allowLeavePage,
    notallowLeavePage,
};

function allowLeavePage() { return { type: userConstants.ALLOW_LEAVE_PAGE } }
function notallowLeavePage() { return { type: userConstants.NOT_ALLOW_LEAVE_PAGE } }

function userFetching() { return { type: userConstants.USER_FETCHING } }
function userFetched() { return { type: userConstants.USER_FETCHED } }

function userSubmitting() { return { type: userConstants.USER_SUBMITTING } }
function userSubmitted() { return { type: userConstants.USER_SUBMITTED } }

function getCurrentVersion(id) {
    return dispatch => {
        dispatch(allowLeavePage());
        dispatch(userFetching());
        userService.getCurrentVersion(id)
            .then(
                currentVersion => {
                    dispatch(userFetched());
                    dispatch(success(currentVersion));
                },
                error => {
                    dispatch(userFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(currentVersion) { return { type: userConstants.CURRENT_VERSION, currentVersion } }
}

function getAllUsers(skip, take, filter, search) {
    return dispatch => {
        dispatch(allowLeavePage());
        dispatch(userFetching());
        userService.getAllUsers(skip, take, filter, search)
            .then(
                users => {
                    if (users.user && users.user.length > 0) {
                        dispatch(success(users));
                        dispatch(userFetched());
                    } else {
                        dispatch(userFetched());
                        dispatch(alertActions.warning(users.message))
                    }
                },
                error => {
                    dispatch(userFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(users) { return { type: userConstants.GET_USERS, users } }
}
function getUserById(id) {
    return dispatch => {
        dispatch(allowLeavePage());
        dispatch(userFetching());
        userService.getUserById(id)
            .then(
                user => {
                    dispatch(success(user));
                    dispatch(userFetched());
                },
                error => {
                    dispatch(userFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(user) { return { type: userConstants.GET_USER_BY_ID, user } }
}
function getUserByIdLogin(id) {
    return dispatch => {
        dispatch(allowLeavePage());
        dispatch(userFetching());
        userService.getUserById(id)
            .then(
                userlogin => {
                    dispatch(success(userlogin));
                    dispatch(userFetched());
                },
                error => {
                    dispatch(userFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(userlogin) { return { type: userConstants.GET_USER_BY_ID_LOGIN, userlogin } }
}
function createUser(payload) {
    return dispatch => {
        dispatch(userSubmitting());
        dispatch(notallowLeavePage());
        userService.createUser(payload)
            .then(
                success => {
                    dispatch(userSubmitted());
                    dispatch(allowLeavePage());
                    dispatch(alertActions.success('User added successfully'))
                    window.location.href = '/system_account/users';
                },
                error => {
                    dispatch(userSubmitted());
                    dispatch(alertActions.error(error.toString()))
                    dispatch(allowLeavePage());
                }
            );
    };
}
function updateUser(payload, id) {
    return dispatch => {
        dispatch(userSubmitting());
        dispatch(notallowLeavePage());
        userService.updateUser(payload, id)
            .then(
                success => {
                    dispatch(userSubmitted());
                    dispatch(allowLeavePage());
                    dispatch(alertActions.success('User updated successfully'))
                    window.location.href = '/system_account/users';

                },
                error => {
                    dispatch(userSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function updateUserCy(payload, userId, id) {
    return dispatch => {
        dispatch(userSubmitting());
        dispatch(notallowLeavePage());
        userService.updateUserCy(payload, userId)
            .then(
                user => {
                    dispatch(userSubmitted());
                    dispatch(allowLeavePage());
                    updateUserData(id, user);
                    dispatch(alertActions.success('User CY Updated successfully'))
                },
                error => {
                    dispatch(userSubmitted());
                    dispatch(allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function updateUserBranch(payload, userId, id) {
    return dispatch => {
        dispatch(userSubmitting());
        dispatch(notallowLeavePage());
        userService.updateUserBranch(payload, userId)
            .then(
                user => {
                    dispatch(userSubmitted());
                    dispatch(allowLeavePage());
                    updateUserDataBranch(id, user);
                    dispatch(alertActions.success('User Branch Updated successfully'))
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                },
                error => {
                    dispatch(userSubmitted());
                    dispatch(allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function deleteUser(id, type) {
    return dispatch => {
        dispatch(notallowLeavePage());
        userService.deleteUser(id)
            .then(
                success => {
                    dispatch(allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('User deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/system_account/users';
                            break;
                        default:
                            dispatch(getAllUsers(0, 20));
                            break;
                    }
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            window.location.href = '/system_account/users';
                            break;
                        default:
                            dispatch(getAllUsers(0, 20));
                            break;
                    }
                }
            );
    };
}
function activation(id, isActive) {
    return dispatch => {
        dispatch(notallowLeavePage());
        userService.activation(id, isActive)
            .then(
                success => {
                    dispatch(allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getUserById(id));
                    dispatch(alertActions.success(isActive ? 'User activated successfully' : 'User deactivated successfully'))
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getUserById(id));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function setup(userId, token, password) {
    return dispatch => {
        dispatch(userFetching());
        dispatch(notallowLeavePage());
        userService.setup(userId, token, password)
            .then(
                success => {
                    dispatch(allowLeavePage());
                    dispatch(userFetched());
                    dispatch(stopSetup());
                    dispatch(alertActions.success('Congratulations! You successfully setup your account. You can now login.'));
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(userFetched());
                    dispatch(stopSetup());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function stopSetup() { return { type: userConstants.SETUP_USER } }
}
function login(username, password) {
    return dispatch => {
        dispatch(userFetching());
        dispatch(notallowLeavePage());
        userService.login(username, password)
            .then(
                user => {
                    dispatch(allowLeavePage());
                    dispatch(userFetched());
                    window.location.href = '/';
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(userFetched());
                    dispatch(loginFail());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    // function loginSuccess(user) { return { type: userConstants.LOGIN_USER_SUCCESS, user } }
    function loginFail() { return { type: userConstants.LOGIN_USER_FAIL } }
}
function logout(id, userId) {
    return dispatch => {
        dispatch(notallowLeavePage());
        userService.logout(userId).then(
            user => {
                dispatch(allowLeavePage());
                dispatch(userFetched());
                removeUser(id);
                window.location.href = '/';
            },
            error => {
                dispatch(allowLeavePage());
                dispatch(userFetched());
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
}
function resendEmail(userId, template) {
    return dispatch => {
        // var userId = user.userId ? user.userId : user;
        dispatch(userSubmitting());
        dispatch(notallowLeavePage());
        userService.resendEmail(userId, template)
            .then(
                success => {
                    dispatch(allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(userSubmitted());
                    dispatch(getUserById(userId));
                    dispatch(alertActions.success('Email was sent successfully'))
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(userSubmitted());
                    dispatch(getUserById(userId));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function helpSupport(payload) {
    return dispatch => {
        dispatch(userSubmitting());
        dispatch(notallowLeavePage());
        userService.helpSupport(payload)
            .then(
                success => {
                    dispatch(allowLeavePage());
                    dispatch(userSubmitted());
                    dispatch(alertActions.success('Message successfully sent!'))
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(userSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            )
    }
}
function updateUserProfile(user, userProfile) {
    return dispatch => {
        dispatch(userSubmitting());
        dispatch(notallowLeavePage());
        userService.updateUser(user, userProfile)
            .then(
                success => {
                    dispatch(allowLeavePage());
                    dispatch(userSubmitted());
                    dispatch(alertActions.success('User updated successfully'))
                    window.location.href = '/myAccount';
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(userSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}
function changePassword(user) {
    return dispatch => {
        dispatch(changePassword(user));
        dispatch(notallowLeavePage());
        userService.changePassword(user)
            .then(
                success => {
                    dispatch(allowLeavePage());
                    dispatch(alertActions.success('User Change Password successfully'))
                    window.location.href = '/myAccount';
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function changePassword() { return { type: userConstants.CHANGE_PASSWORD } }
}

function changePasswordAdmin(user) {
    return dispatch => {
        // dispatch(changePasswordAdmin(user));
        dispatch(userSubmitting());
        dispatch(notallowLeavePage());
        userService.changePasswordAdmin(user)
            .then(
                success => {
                    dispatch(allowLeavePage());
                    dispatch(alertActions.success('User Change Password successfully'));
                    dispatch(userSubmitted());
                    window.location.reload();
                },
                error => {
                    dispatch(allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(userSubmitted());
                }
            );
    };
    // function changePasswordAdmin() { return { type: userConstants.CHANGE_PASSWORD_ADMIN } }
}